// export const backendUrl = "https://oj-be.priyanshudevsingh.me";
// export const backendUrl = "http://localhost:5000";
export const backendUrl = "http://44.200.146.17:5000";
